import { FormGroup } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";

import TextWidget from "common/form/widgets/TextWidget";
import { ILinkType, LinkTypeRegistry } from "common/views/menuTree/ILinkType";
import Label from "core/components/label/Label";
import Logger from "core/util/Logger";
import TokenSession from "core/util/session/TokenSession";


interface ISignInOutLink {
	signInLabel: string;
	signInIcon: string;
	signOutLabel: string;
	signOutIcon: string;
}

const signInOutLink: ILinkType<ISignInOutLink> = {
	type: "signinout",
	label: "Sign In/Sign Out Link",
	icon: IconNames.LOG_IN,
	renderInput: (value, onChange: (value) => void) => (
		<React.Fragment>
			<FormGroup label="Sign In Label">
				<TextWidget onChange={(signInLabel) => onChange({...value, signInLabel})} value={value.signInLabel} />
			</FormGroup>
			<FormGroup label="Sign In Icon">
				<TextWidget onChange={(signInIcon) => onChange({...value, signInIcon})} value={value.signInIcon} />
			</FormGroup>
			<FormGroup label="Sign Out Label">
				<TextWidget onChange={(signOutLabel) => onChange({...value, signOutLabel})} value={value.signOutLabel} />
			</FormGroup>
			<FormGroup label="Sign Out Icon">
				<TextWidget onChange={(signOutIcon) => onChange({...value, signOutIcon})} value={value.signOutIcon} />
			</FormGroup>
		</React.Fragment>
	),
	canAddChildren: false,
	mapDataToMenuNode: (data, {id}) => {

		const isLoggedIn = TokenSession.isAuthenticated();

		return {
			id,
			data,
			label: (
				<Label
					k={`link.${isLoggedIn ? 'signout' : 'signin'}`}
					v={isLoggedIn ? (data.signOutLabel || "Sign Out") : (data.signInLabel || "Sign In")}
				/>
			),
			icon: isLoggedIn ? data.signOutIcon : data.signInIcon
		};
	},
	doNavigate: () => {
		if (TokenSession.isAuthenticated()) {
			TokenSession.logout();
		} else {
			TokenSession.refresh();
		}
	}
};

export default LinkTypeRegistry.registerType(signInOutLink);



// WEBPACK FOOTER //
// ./src/common/views/menuTree/linkTypes/SignInOutLink.tsx